import React, { useEffect, useState,useRef } from "react";
import { Card, Button, CardBody, Col, Container, Row, Nav, NavItem, NavLink, TabContent, TabPane, CardText, Alert } from "reactstrap";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import { subscribeToTokenRefresh } from "../../../helpers/Refreshfile";
import axios from "axios";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import classnames from "classnames";
import { format } from 'date-fns';
import { DateTime } from 'luxon';

interface AvailabilityData {
    [date: string]: string[];
}

const PAST_AVL_MSG = "You cannot add availability for dates or times that have already passed.";

const apiErrorMessage = (error: any): string | undefined => {
    const d = error?.response?.data;
    if (d == null) return undefined;
    if (typeof d === "string") return d;
    if (d.error != null && d.error !== "") return String(d.error);
    if (d.detail != null) {
        if (typeof d.detail === "string") return d.detail;
        if (Array.isArray(d.detail)) return d.detail.map(String).join(" ");
        return JSON.stringify(d.detail);
    }
    if (Array.isArray(d.non_field_errors) && d.non_field_errors.length) {
        return String(d.non_field_errors[0]);
    }
    return undefined;
};

const ExpAvailability = () => {

    // REmoveable code of timezones testing Purposes
    useEffect(() => {
        const currentLaTime = DateTime.now().setZone('America/Los_Angeles').toFormat('ff');
        const currentCanadaTime = DateTime.now().setZone('America/Toronto').toFormat('ff');
        const currentLocalTime = DateTime.now().toFormat('ff');
        
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const date = new Date(); // current time
        const localTime = DateTime.fromJSDate(date).setZone(userTimeZone);

        
        console.log("🕒 Converted to Local TZ:", localTime.toFormat("ff"));
        console.log("🖥️ Local System Time:", currentLocalTime);
        console.log("🇨🇦 Canada Time:", currentCanadaTime);
        console.log("LA Time:", currentLaTime);
    }, []);
    // REmoveable code of timezones testing Purposes



    const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'4000'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false })
    };
    const [showloader, setshowloader] = useState(true);


    // const flatpickrRef = useRef(null); 
    const [selectedViewDate, setSelectedViewDate] = useState<string>('');
    const flatpickrRefAdd = useRef<Flatpickr | null>(null); 
    const flatpickrRefView = useRef<Flatpickr | null>(null);
    const amSlots = [
        '12:00 AM', '12:30 AM', '1:00 AM', '1:30 AM', '2:00 AM', '2:30 AM',
        '3:00 AM', '3:30 AM', '4:00 AM', '4:30 AM', '5:00 AM', '5:30 AM',
        '6:00 AM', '6:30 AM', '7:00 AM', '7:30 AM', '8:00 AM', '8:30 AM',
        '9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM',
    ];

    const pmSlots = [
        '12:00 PM', '12:30 PM', '1:00 PM', '1:30 PM', '2:00 PM', '2:30 PM',
        '3:00 PM', '3:30 PM', '4:00 PM', '4:30 PM', '5:00 PM', '5:30 PM',
        '6:00 PM', '6:30 PM', '7:00 PM', '7:30 PM', '8:00 PM', '8:30 PM',
        '9:00 PM', '9:30 PM', '10:00 PM', '10:30 PM', '11:00 PM', '11:30 PM',
    ];

    const [showAvailability, setShowAvailability] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [customActiveTab, setcustomActiveTab] = useState("1");
    const [selectedDate, setSelectedDate] = useState<string[]>([]);
    const [selectedSlots, setSelectedSlots] = useState<string[]>([]);
    const [availabilityData, setAvailabilityData] = useState<AvailabilityData>({});
    const [selectedAvailabilityDate, setSelectedAvailabilityDate] = useState<string>('');
    const [expertTimezone, setExpertTimezone] = useState<string>('');

    const validateAvailabilityNotPast = (): string | null => {
        const tz = expertTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
        const now = DateTime.now().setZone(tz);
        for (const dateStr of selectedDate) {
            const dayStart = DateTime.fromISO(dateStr, { zone: tz }).startOf("day");
            if (!dayStart.isValid) continue;
            if (dayStart < now.startOf("day")) {
                return PAST_AVL_MSG;
            }
            if (dayStart.toFormat("yyyy-MM-dd") !== now.toFormat("yyyy-MM-dd")) {
                continue;
            }
            for (const slot of selectedSlots) {
                const start = DateTime.fromFormat(`${dateStr} ${slot}`, "yyyy-MM-dd h:mm a", { zone: tz });
                if (!start.isValid) continue;
                const end = start.plus({ minutes: 30 });
                if (now >= end) {
                    return PAST_AVL_MSG;
                }
            }
        }
        return null;
    };

    const handleCheckboxChange = (time: string) => {
        const newSelectedSlots = selectedSlots.includes(time)
            ? selectedSlots.filter(slot => slot !== time)
            : [...selectedSlots, time];
        setSelectedSlots(newSelectedSlots);
        const allSlots = [...amSlots, ...pmSlots];
        setIsChecked(allSlots.every(slot => newSelectedSlots.includes(slot)));
    };

    const toggleCheckboxes = () => {
        const allSlots = [...amSlots, ...pmSlots];
        if (!isChecked) {
            setSelectedSlots([...new Set([...selectedSlots, ...allSlots])]);
        } else {
            setSelectedSlots([]);
        }
        setIsChecked(!isChecked);
    };

    const clearAllDates = () => {
        if (flatpickrRefAdd.current) {
            flatpickrRefAdd.current.flatpickr.clear();
        }
        setSelectedDate([]);
        handleDateChange([]);
        setShowAvailability(false);
        
    };

    // const handleDateChange = (dates: Date[]) => {
    //     const formattedDates = dates.map(date => format(date, 'yyyy-MM-dd'));
    //     console.log('handleDateChange',formattedDates)
    //     setSelectedDate(formattedDates);
    // };
    // const handleDateChange = (dates: Date[]) => {
    //     const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    //     const formattedDates = dates.map(date => {
    //         const localTime = DateTime.now().setZone(userTimeZone);
    //         console.log("🕒 Local time converted:", localTime.toFormat('ff'));

    //         const laTime = DateTime.now().setZone('America/Los_Angeles');
    //         const torontoTime = DateTime.now().setZone('America/Toronto');
    //         console.log("🎥 LA Time:", laTime.toFormat('ff'));
    //         console.log("🍁 Toronto Time:", torontoTime.toFormat('ff'));
    //         return localTime.toFormat('yyyy-MM-dd');
    //     });

    //     console.log('📅 Final formatted dates:', formattedDates);
    //     setSelectedDate(formattedDates);
    // };
    const handleDateChange = (dates: Date[]) => {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const formattedDates = dates.map(date => {
            const localTime = DateTime.fromJSDate(date).setZone(userTimeZone);
            console.log("🕒 Local time converted:", localTime.toFormat('ff'));
            return localTime.toFormat('yyyy-MM-dd');
        });

        setSelectedDate(formattedDates); // list of selected dates
    };
    const handleViewDateChange = (dates: Date[]) => {
        if (dates.length > 0) {
            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const selectedDate = DateTime.fromJSDate(dates[0]).setZone(userTimeZone).startOf('day');
            const selectedDateStr = selectedDate.toFormat('yyyy-MM-dd');
            console.log("🕒 Selected view date:", selectedDateStr);
            setSelectedViewDate(selectedDateStr); // used in UI for "No slots"
            setSelectedAvailabilityDate(selectedDateStr); // used to fetch/check slots
        } else {
            setSelectedViewDate('');
            setSelectedAvailabilityDate('');
        }
    };

    const toggleCustom = (tab: string) => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };


    const AvailabilityToBackend = async () => {
        if (selectedDate.length === 0) {
            setAlertMsgg({ ...alertMsgg, open: true, content:"Please select a date first.", type:"error" })
            setTimeout(() => { setAlertMsgg(prev => ({ ...prev, open: false })); }, 3000); 
            return;
        }
        if (selectedSlots.length === 0) {
            setAlertMsgg({ ...alertMsgg, open: true, content:"Please select at least one time slot.", type:"error" }) 
            setTimeout(() => { setAlertMsgg(prev => ({ ...prev, open: false})); }, 3000)
            return;
        }
        const pastErr = validateAvailabilityNotPast();
        if (pastErr) {
            setAlertMsgg({ ...alertMsgg, open: true, content: pastErr, type: "error" });
            setTimeout(() => { setAlertMsgg(prev => ({ ...prev, open: false })); }, 4000);
            return;
        }
        try {
            setshowloader(true)
            const response = await axios.post('/accounts/update_exp_avl', {
                selectedDate,
                selectedSlots,
            });

            console.log('Backend Response:', response);
            if (response.status === "UPDATED") {
                setshowloader(false)
                setAlertMsgg({ ...alertMsgg, open: true, content:`Availability updated successfully!`, type:"success" })
                setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000);
                
                // setAlertMsgg({ ...alertMsgg, open: true, content:"Availability updated successfully!", type:"success" }) 
                setSelectedDate([]);
                setSelectedSlots([]);
                setIsChecked(false);
                getAvailabilityformBackend()
                clearAllDates()
            } else {
                setshowloader(false)
                setAlertMsgg({ ...alertMsgg, open: true, content: response.error || "Failed to update availability", type: "error" });
            }
        } catch (error:any) {
            const msg = apiErrorMessage(error);
            if (error.response) {
                if ([401, 400, 422].includes(error.response.status)) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: msg || "Request could not be completed.", type: "error" });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout"; }, 2000);
                } else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: msg || "An error occurred", type: "error" });
                }
            } else {
                setAlertMsgg({
                    ...alertMsgg,
                    open: true,
                    content: error?.message === "Network Error" ? "Network error — check your connection." : (error?.message || "Something went wrong"),
                    type: "error",
                });
            }
            setshowloader(false)
        }
    };


    const getAvailabilityformBackend = async () => {
        try {
            setshowloader(true)
            const response = await axios.get('/accounts/get_expert_settings', {});

            if (response.status === "SENT") {
                setExpertTimezone(response.expert?.timezone || "");
                const availabilityDict = response.expert.availabilty || {};
                setAvailabilityData(availabilityDict);
                
                console.log('availabilityDict',availabilityDict)
                
                if (flatpickrRefView.current) {
                    flatpickrRefView.current.flatpickr.clear();
                }
                const availableDates = Object.keys(availabilityDict).map(dateStr => {
                    const [year, month, day] = dateStr.split('-').map(Number);
                    return new Date(year, month - 1, day);
                });
                
                if (availableDates.length > 0) {
                    setSelectedAvailabilityDate(Object.keys(availabilityDict)[0]);
                    
                    
                    if (flatpickrRefView.current) {
                        setTimeout(() => {
                            flatpickrRefView.current?.flatpickr.clear();
                            // flatpickrRefView.current?.flatpickr.setDate(availableDates);
                            console.log('Calendar dates set:', 
                                availableDates.map(d => 
                                    `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')}`
                                )
                            );
                        }, 100);
                    }
                }
                setshowloader(false)
            } else {
                setshowloader(false)
                setAlertMsgg({ ...alertMsgg, open: true, content: "Failed to load availability data", type: "error" });
            }
        } catch (error:any) {
            const msg = apiErrorMessage(error);
            if (error.response) {
                if ([401, 400, 422].includes(error.response.status)) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: msg || "Failed to load availability data", type: "error" });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout"; }, 2000);
                } else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: msg || "An error occurred", type: "error" });
                }
            } else {
                setAlertMsgg({
                    ...alertMsgg,
                    open: true,
                    content: error?.message === "Network Error" ? "Network error — check your connection." : (error?.message || "Something went wrong"),
                    type: "error",
                });
            }
            setshowloader(false)
        }
    };

    useEffect(() => {
        getAvailabilityformBackend();

        subscribeToTokenRefresh(() => {
            console.log("🔁 Token refreshed. Re-fetching experts...");
            getAvailabilityformBackend();
        });


        document.title = "BizServe | Availability";
    }, []);

    const initgsync = async () => {
        // const openloader = document.querySelector('.loaderWeb') as HTMLElement | null;
        // if (openloader) {openloader.style.display = 'flex';}     
        try{
            setshowloader(true)
            const response = await axios.post(`/calendars/google/events`, {}, { withCredentials: true ,headers: { 'Content-Type': 'application/json' }});
            if (response.status === "REDIRECT"){ window.location.href = response.rurl; setshowloader(false) }   
            if (response.status === "CONNECTED"){
                const eventlog = await axios.post(`/calendars/google/events`, {}, { withCredentials: true ,headers: { 'Content-Type': 'application/json' }});
                if (eventlog.status === "SYNCED"){ 
                    setshowloader(false)
                    getAvailabilityformBackend();
                    setAlertMsgg({ ...alertMsgg, open: true, content:"Synchronized!", type:"success" }) 
                }
            }   
            if (response.status === "SYNCED"){ 
                setshowloader(false)
            
                getAvailabilityformBackend();
                setAlertMsgg({ ...alertMsgg, open: true, content:"Synchronized!", type:"success" }) 
            }   
        } catch (error:any) {
            const msg = apiErrorMessage(error);
            if (error.response) {
                if ([401, 400, 422].includes(error.response.status)) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: msg || "Request could not be completed.", type: "error" });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout"; }, 2000);
                } else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: msg || "An error occurred", type: "error" });
                }
            } else {
                setAlertMsgg({
                    ...alertMsgg,
                    open: true,
                    content: error?.message === "Network Error" ? "Network error — check your connection." : (error?.message || "Something went wrong"),
                    type: "error",
                });
            }
            setshowloader(false)
        }
    };

    return (
        <React.Fragment>
            {alertMsgg.open && (
            <Alert
            color={alertMsgg.type === "success" ? "success" : "danger"}
            toggle={handleAlertMsggClose}
            style={{ fontWeight: "bold" }}
            >
            {alertMsgg.content}
            </Alert>
            )}
            <div className="loaderContainer" hidden={!showloader}>
            <div className="spinner">
            <div></div>  
            <div></div>    
            <div></div>    
            <div></div>    
            <div></div>    
            <div></div>    
            <div></div>    
            <div></div>    
            <div></div>    
            <div></div>    
            </div>
        </div>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Expert" breadcrumbItem="Availability" />
                    {/* Your toggle */}
                    <div className="d-flex justify-content-end mb-n5">
                        <div className="form-check form-switch form-switch-lg mb-3 position-relative z-1">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="customSwitchsizelg"
                                onChange={() => setShowAvailability(!showAvailability)}
                            />
                            <label className="form-check-label" htmlFor="customSwitchsizelg">
                                Show Availability
                            </label>
                        </div>
                    </div>

                    {/* Add Availability */}
                    <Row className={showAvailability ? 'd-none' : ''}>
                        <Col md={5}>
                            <Card className="rounded-4 stickThat">
                                <CardBody>
                                    <p className="text-dark font-size-18 fw-medium">Add Availability</p>
                                    <div className="form-group mb-0 styleAvail">
                                        <div className="d-flex justify-content-between mb-3">
                                            <label className="font-size-15 text-dark">Select date to add slots for<span className="text-danger px-1">*</span></label>
                                            {/* <label className="font-size-15 text-dark">Select Time Slots</label> */}
                                            <Button
                                                onClick={clearAllDates} // Clears all selected dates
                                                color="danger"
                                                className="btn btn-sm"
                                            >
                                                Clear All Dates
                                            </Button>
                                        </div>
                                        <Flatpickr
                                            ref={flatpickrRefAdd}
                                            className="form-control d-block"
                                            placeholder="dd M,yyyy"
                                            options={{
                                                inline: true,
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                mode: "multiple",
                                                dateFormat: "Y-m-d"
                                            }}
                                            onChange={handleDateChange}
                                        />
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col md={7}>
                            {/* AM / PM tabs */}
                            <Row className="mb-2">
                                <Col md={4}>
                                    <Nav tabs className="nav-tabs-custom nav-justified">
                                        <NavItem>
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames({ active: customActiveTab === "1" })}
                                                onClick={() => toggleCustom("1")}
                                            >
                                                <span className="d-block">AM</span>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames({ active: customActiveTab === "2" })}
                                                onClick={() => toggleCustom("2")}
                                            >
                                                <span className="d-block">PM</span>
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </Col>
                            </Row>

                            {/* Time Slots */}
                            <TabContent activeTab={customActiveTab} className="text-muted">
                                <TabPane tabId="1">
                                    {renderSlotList(amSlots)}
                                </TabPane>
                                <TabPane tabId="2">
                                    {renderSlotList(pmSlots)}
                                </TabPane>
                                <div className="d-flex justify-content-end">
                                    <Button color="primary" className="btn btn-md me-2" onClick={AvailabilityToBackend} >
                                        Add Availability
                                    </Button>
                                </div>
                            </TabContent>
                        </Col>
                    </Row>
                    <Row className={showAvailability ? '' : 'd-none'}>
                        <Col md={5}>
                            <Card className="rounded-4 bg-primary bg-opacity-25  shadow-lg">
                                <CardBody>
                                    <p className="text-dark font-size-18 fw-medium">Current Availability</p>
                                    <label className="font-size-15 text-dark mb-4">Select Date to show it's slots.<span className="text-danger px-1">*</span></label>
                                    <div className="form-group mb-0 styleAvail">
                                        
                                        <Flatpickr
                                            ref={flatpickrRefView}
                                            className="form-control d-block"
                                            placeholder="dd M,yyyy"
                                            options={{
                                                inline: true,
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: "Y-m-d",
                                                mode: "single",
                                                defaultDate: null,
                                            }}
                                            onChange={handleViewDateChange}
                                        />
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={7}>
                            <Row className="mb-2">
                                <Col md={12}>
                                    <p className="text-dark font-size-18 fw-medium">
                                        Available Slots
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <CardText className="mb-0">
                                        <div className="text-end mb-2">
                                            <button type="button" className="btn btn-dark text-uppercase" onClick={initgsync}>
                                                <i className="bx bx-calendar-event font-size-16 align-middle me-2"></i>
                                                Sync Availability with Google
                                            </button>
                                        </div>

                                        {selectedViewDate && availabilityData[selectedViewDate]?.length > 0 ? (
                                            (availabilityData[selectedViewDate]?.length == 48) ? (
                                            <Card className="rounded-4">
                                                <CardBody className="p-5">
                                                    <div className="text-center">
                                                        <i className="display-2 bx bx-check-circle text-success"></i>
                                                        <h4 className="text-success">All day available.</h4>
                                                        {/* <p className="text-muted">
                                                            All Slots available for {format(new Date(selectedViewDate), 'MMMM d, yyyy')}.
                                                        </p> */}
                                                        <p className="text-muted">
                                                            All Slots available for {DateTime.fromISO(selectedViewDate)
                                                                .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat('MMMM d, yyyy')}.
                                                        </p>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                            ) : (
                                            <Card className="rounded-4">
                                                <CardBody>
                                                    <p className="text-muted mb-2">
                                                        Available slots for : {DateTime.fromISO(selectedViewDate)
                                                            .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
                                                            .toFormat('MMMM d, yyyy')}
                                                    </p>
                                                    <div className="d-flex availCard flex-wrap">
                                                        {availabilityData[selectedViewDate].map((time, index) => (
                                                            <div className="form-check mb-2 ps-0 pe-2" key={index}>
                                                                <input
                                                                    className="form-check-input d-none"
                                                                    type="checkbox"
                                                                    id={`timeCheck${index}`}
                                                                    value={time}
                                                                    defaultChecked={true}
                                                                    disabled={true}
                                                                />
                                                                <label className="form-check-label" htmlFor={`timeCheck${index}`}>
                                                                    {time}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </CardBody>
                                            </Card>)
                                        ) : selectedViewDate ? (
                                            <Card className="rounded-4">
                                                <CardBody className="p-5">
                                                    <div className="text-center">
                                                        <i className="display-2 mdi mdi-alert-circle-outline text-danger"></i>
                                                        <h4 className="text-danger">No Slots Available</h4>
                                                        <p className="text-muted">
                                                            No available slots for {DateTime.fromISO(selectedViewDate).setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat('MMMM d, yyyy')}
                                                        </p>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        ) : (
                                            <Card className="rounded-4">
                                                <CardBody className="p-5">
                                                    <div className="text-center">
                                                        <i className="display-2 mdi mdi-calendar-blank text-primary"></i>
                                                        <h4 className="text-primary">Select a Date</h4>
                                                        <p className="text-muted">Please select a date to view available slots</p>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        )}
                                    </CardText>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );

    function renderSlotList(slots: string[]) {
        return (
            <Row>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Card className="rounded-4 stickThat">
                            <CardBody>
                                <div className="d-flex justify-content-between mb-3">
                                    <label className="font-size-15 text-dark">Select Time Slots<span className="text-danger px-1">*</span></label>
                                    <Button
                                        onClick={toggleCheckboxes}
                                        color="dark"
                                        className="btn btn-sm me-2"
                                    >
                                        {isChecked ? "Unselect All Slots" : "Select All Slots"}
                                    </Button>
                                </div>
                                <div className="d-flex availCard flex-wrap">
                                    {slots.map((time, index) => (
                                        <div className="form-check mb-2 ps-0 pe-2" key={index}>
                                            <input
                                                className="form-check-input d-none"
                                                type="checkbox"
                                                id={`defaultCheck${time.replace(/\s/g, '')}`}
                                                value={time}
                                                checked={selectedSlots.includes(time)}
                                                onChange={() => handleCheckboxChange(time)}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={`defaultCheck${time.replace(/\s/g, '')}`}
                                            >
                                                {time}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </CardBody>
                        </Card>
                    </CardText>
                </Col>
            </Row>
        );
    }
};

export default ExpAvailability;
